/* eslint-disable @next/next/no-img-element */
import { ElementProps } from '@/components/sections/builder/types';
import {
  ImageElementDataType,
  ImageGalleryElementDataType,
} from '@/components/sections/builder/elements/body/image-gallery/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';

import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import React from 'react';
import { shallow } from 'zustand/shallow';
import { Images } from 'lucide-react';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import useMediaQuery from '@/hooks/useMediaQuery';
import Link from 'next/link';
import InputLink from '@/components/sections/builder/settings/input-link';

const defaultData: ImageElementDataType = {
  name: 'Image',
  img: 'https://placehold.co/300x400?text=Image temporary 1',
  mobileMinWidth: 720,
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ImageElementDataType;
  const parentData = (element.parentData || {}) as ImageGalleryElementDataType;

  const imgUrl = useMediaQuery(data.mobileMinWidth) && data.mobileImg ? data.mobileImg : data.img;

  return (
    <Link href={data.imgLink || '#'}>
      <img
        className={clsx('theme_media h-auto w-full object-cover', parentData.imageRatio)}
        src={imgUrl}
        data-animation='true'
        data-animation-group={`gallery-item-${element.parentId}`}
        alt=''
      />
    </Link>
  );
};

export const ElementPreviewIcon = Images;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ImageElementDataType;

  return (
    <div>
      <div className='mb-4 mt-4 font-bold'>Image</div>
      <ImageSetting
        value={data?.img}
        onChange={(v) => {
          builder.setChildData(element.parentId as string, element.id, {
            img: v,
          });
        }}
      />
      <div className='mb-2 mt-4'>Mobile image (optional)</div>
      <ImageSetting
        value={data?.mobileImg}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            mobileImg: val,
          });
        }}
      />
      <InputSlider
        label='Device under this size use mobile image'
        value={data.mobileMinWidth || 0}
        max={1440}
        min={0}
        rightContent={<div>px</div>}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            mobileMinWidth: val,
          })
        }
      />
      <div className='mb-4 mt-4  font-bold'>Image Link</div>
      <InputLink
        name='url_path_img'
        placeholder='Search or enter a link'
        onChange={(value) => {
          builder.setChildData(element.parentId as string, element.id, {
            imgLink: value,
          });
        }}
        value={data.imgLink as string}
      />
    </div>
  );
}

const Image = {
  type: 'image',
  group: 'image_gallery',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default Image;
